import React, { useCallback, useMemo } from 'react';
import clsx from 'clsx';
import { ButtonProps } from './types';
import { Bubbles } from '../Loading';
import './index.less';

const Button = ({
  children,
  disabled,
  loading,
  onClick,
  className,
  type,
  size = 'large',
  color = 'primary',
  as: Cmp = 'div',
  plain,
  ...rest
}: ButtonProps) => {
  const handleClick = useCallback(
    (e: { preventDefault: () => void }) => {
      if (disabled || loading) {
        e.preventDefault();
        return;
      }
      if (onClick) {
        onClick();
      }
    },
    [disabled, loading, onClick],
  );

  const _className: string = useMemo(() => {
    return clsx(`btn${type ? `-${type}` : ''}`, className, [size, color], {
      loading,
      disabled,
      plain,
    });
  }, [className, size, color, type, loading, disabled, plain]);

  const loadingColor =
    !plain && ['primary', 'secondary'].includes(color) ? 'surface' : 'primary';

  return (
    <Cmp className={_className} onClick={handleClick} {...rest}>
      {loading ? <Bubbles color={loadingColor} /> : children}
    </Cmp>
  );
};

export default Button;
